import React, { useRef } from "react";
import { motion } from "framer-motion";
import CirculoLogo from "./tarjetaTrabajaconNos.js";

const BienvenidaInstitucional = () => {
  const fileInputRef = useRef();

  const handleEnviarCV = () => {
    const file = fileInputRef.current.files[0];
    if (!file) {
      alert("Por favor, seleccioná tu archivo antes de enviar.");
      return;
    }

    window.location.href =
      "mailto:administracion@fundacioncolegiosantotomas.com.ar?subject=Envío%20de%20CV&body=Adjunto%20mi%20currículum.%0A%0A*Por favor no olvides adjuntar el archivo antes de enviar este correo.*";
  };

  return (
    <div className="min-h-screen flex flex-col items-center px-6 pt-16 bg-gradient-to-br from-white to-[#e9f5f1] text-center">
      <div className="mb-8">
        <CirculoLogo />
      </div>
      <div className="mt-4">
        <input type="file" ref={fileInputRef} accept=".pdf,.doc,.docx"  className="form-control fw-bold" 
                                              style={{ maxWidth: "400px", margin: "0 auto" }}  />
        <small className="d-block mt-2">Formatos permitidos: .pdf, .doc, .docx</small>
      </div>
      <button onClick={handleEnviarCV} className="btn btn-primary fw-bold px-4 py-2 mt-3 mb-5">
        Enviar CV
      </button>
    </div>
  );
};

export default BienvenidaInstitucional;
